export const appSettingsAppIdentifiers = "/app_settings/app_identifiers(/:app_group_id)";
